// @flow
import React from 'react'
import styled from 'styled-components'
import { translateFunc, translations } from '../../shared/localize'

import type { Public } from '../types'
import type { Errors } from '../AudienceEdit'
import SocialPublicSelect from './SocialPublicSelect'
import type { SocialPublicProps } from '../../redux/ducks/audienceEdit/reducers'
import LabeledWrapper from './LabeledWrapper'

const t = translateFunc(translations.audience_edit.public_fields)

const SelectWrapper = styled.div`
  display: inline-block;
  width: 480px;
  padding-top: 5px;
`

type Props = {|
  currentAdAccountId: number,
  onVkPublicChange: (Public) => void,
  onFbPublicChange: (Public) => void,
  vkPublic?: Public,
  fbPublic?: Public,
  vkPublicErrors?: Errors,
  fbPublicErrors?: Errors,
  isVkEditDisabled: boolean,
  isFbEditDisabled: boolean,
  isOrtAccounts: boolean,
  isVkPublicVisible: boolean,
  isFbPublicVisible: boolean,
  socialPublicProps: SocialPublicProps
|}

export default function SocialPublics(props: Props) {
  const {
    currentAdAccountId,
    vkPublic,
    fbPublic,
    onVkPublicChange,
    onFbPublicChange,
    vkPublicErrors,
    fbPublicErrors,
    isVkEditDisabled,
    isFbEditDisabled,
    isVkPublicVisible,
    isFbPublicVisible
  } = props

  return (
    <div>
      {isVkPublicVisible && (
        <LabeledWrapper
          className="t-PublicFields__vk-select"
          label={t('vk_publics')}
          errors={vkPublicErrors}
          twoLines
        >
          <SelectWrapper>
            <SocialPublicSelect
              currentAdAccountId={currentAdAccountId}
              publicObject={vkPublic}
              onPublicChange={onVkPublicChange}
              placeholder={t('vk_placeholder')}
              isEditDisabled={isVkEditDisabled}
              isOrtAccounts={props.isOrtAccounts}
              publicProps={props.socialPublicProps.vkProps}
              commonPublicProps={props.socialPublicProps.common}
            />
          </SelectWrapper>
        </LabeledWrapper>
      )}

      {isFbPublicVisible && (
        <LabeledWrapper
          className="t-PublicFields__fb-select"
          label={t('fb_publics')}
          errors={fbPublicErrors}
          twoLines
        >
          <SelectWrapper>
            <SocialPublicSelect
              currentAdAccountId={currentAdAccountId}
              isOrtAccounts={props.isOrtAccounts}
              publicObject={fbPublic}
              onPublicChange={onFbPublicChange}
              placeholder={t('fb_placeholder')}
              isEditDisabled={isFbEditDisabled}
              publicProps={props.socialPublicProps.fbProps}
              commonPublicProps={props.socialPublicProps.common}
            />
          </SelectWrapper>
        </LabeledWrapper>
      )}
    </div>
  )
}
